import React, { useEffect, useState } from 'react';
import {
	makeStyles,
	Box,
	Grid,
	MenuItem,
	TextField as TextField2,
} from '@material-ui/core';
import { Field, Form, Formik, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { TextField } from 'formik-material-ui';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				// border: "1px solid #959595",
			},
		},
		// backgroundColor: 'white',
		// marginBottom: 30,
		width: '100%',
		border: '1px solid #959595',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .MuiSelect-select': {
			padding: 8,
			border: '1px solid grey',
		},
	},
	InputPropsStyle: {
		// backgroundColor: 'white',
		borderRadius: 15,
	},
	inputPropsStyle: {
		padding: 8,
		border: '1px solid lightgrey',
	},
	root: {
		'& .MuiFormControl-root': {
			'& div': {
				'& div': {
					display: 'none',
				},
			},
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},

		'& input': {
			fontSize: '.8em',
			fontWeight: 600,
			padding: '0px 4px 4px 0px',
			[theme.breakpoints.down('xs')]: {
				fontSize: '12px',
			},
		},
		'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},

		'& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-184whfw-MuiAutocomplete-root .MuiAutocomplete-inputRoot':
			{
				paddingRight: 0,
			},
		'& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-xzqck1-MuiAutocomplete-root .MuiAutocomplete-inputRoot':
			{
				paddingRight: 0,
			},
	},
	radio: {
		'& .MuiRadio-root': {
			color: 'grey',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'black',
			fontSize: '.8em',
			[theme.breakpoints.down('xs')]: {
				fontSize: 10,
			},
			// fontSize: '14px',
			//   fontWeight: 800,
		},
	},
	radio2: {
		'& .MuiRadio-root': {
			color: 'black',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'black',
			fontSize: '.8em',
			[theme.breakpoints.down('xs')]: {
				fontSize: 10,
			},
			// fontSize: '14px',
			// fontWeight: 800,
		},
	},
	popper: {
		'& .MuiAutocomplete-listbox': {
			'& :hover': {
				color: 'rgb(239, 51, 57)',
				// '& img': {
				// 	background: 'rgb(239, 51, 57)',
				// },
			},
		},
	},
}));
const LoginForm = () => {
	const classes = useStyles();
	const [val, setVal] = useState(0);
	const handleFormSubmit = (data) => {
		console.log('Data', data);
	};

	return (
		<>
			<Formik
				initialValues={{
					email: '',
					password: '',
				}}
				validationSchema={Yup.object({
					email: Yup.string()
						.required('email required')
						.email('Enter valid email'),
					password: Yup.string().required('password required'),
				})}
				onSubmit={handleFormSubmit}>
				{(formik) => (
					<Form>
						<Grid
							container
							alignItems='center'
							style={{ marginTop: 20, alignItems: 'baseline' }}>
							<Grid item xs={12} lg={12}>
								{val === 0 ? (
									<>
										<Field
											component={TextField}
											name='email'
											type='text'
											variant='outlined'
											style={{ marginTop: 25 }}
											label='Email Id'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 15 },
											}}
										/>
										<Field
											component={TextField}
											name='password'
											type='password'
											variant='outlined'
											style={{ marginTop: 25 }}
											label='Password'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 15 },
											}}
										/>
									</>
								) : val === 1 ? (
									<>
										<Field
											component={TextField}
											name='email'
											type='text'
											variant='outlined'
											style={{ marginTop: 25 }}
											label='Email Id'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 15 },
											}}
										/>
									</>
								) : (
									''
								)}

								<button
									type='submit'
									style={{
										fontSize: 16,
										cursor: 'pointer',
										width: '100%',
										border: '1px solid yellow',
										padding: 12,
										marginTop: 20,

										borderRadius: 5,
										background: 'yellow',
									}}>
									{val === 0 ? 'Login' : 'Reset'}
								</button>
								<Box
									style={{
										textAlign: 'end',
										marginTop: 10,
										marginBottom: 20,
										cursor: 'pointer',
										justifyContent: 'space-between',
										display: 'flex',
									}}>
									<span style={{ fontSize: 12 }}>
										{val === 0 ? 'Create Account' : ''}
									</span>
									<span
										style={{ fontSize: 12 }}
										onClick={() =>
											val === 0 ? setVal(1) : val === 1 ? setVal(0) : ''
										}>
										{val === 0 ? 'Forqot Password?' : 'Back to Login'}
									</span>
								</Box>
							</Grid>
						</Grid>
					</Form>
				)}
			</Formik>
		</>
	);
};

export default LoginForm;
